import React from 'react';
import Modal from 'react-bootstrap/Modal';


export default function TestDetailModal({ isLoading, isDetail, setIsDetail, testDetails }) {
    return (
        <div>
            <Modal
                show={isDetail}
                size={window.innerWidth > 767 ? "lg" : 'md'}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"test-details"}
            >
                <Modal.Body style={{ minHeight: '500px' }}>
                    <div className='sticky-close'>
                        <img src='/images/close.svg' alt='' onClick={() => setIsDetail(false)} />
                    </div>
                    {
                        isLoading ?
                            <div
                                className="loading-overlay"
                                style={{
                                    alignItems: "center",
                                    color: "#F75891",
                                    height: "50vh",
                                }}
                            >
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">
                                        Loading job summary...
                                    </span>
                                </div>
                            </div> :
                            <div className='d-flex flex-wrap'>
                                <div className='selected-test'>
                                    <div className='selected-list-header'>
                                        <h4>Assessment Summary</h4>
                                        <h5>{testDetails?.testDetails?.tests?.length} test | {testDetails?.questionCount} Qs | {testDetails?.duration} Mins</h5>
                                        {/* <p>Level:Advanced</p> */}
                                    </div>
                                    <div className='selected-list'>
                                        <h1>Selected Tests</h1>

                                        {

                                            <div>
                                                {
                                                    testDetails?.testDetails?.tests && testDetails?.testDetails?.tests?.map((el, index) => {
                                                        return (
                                                            <div className='selected-list-item'>
                                                                <div className='d-flex'>

                                                                    <div>
                                                                        <h1>{el.testName}</h1>
                                                                        <p>{el.testLevelName} | {el.questionCount} Qs | {el.duration} Mins | {el.languageCode}</p>
                                                                    </div>
                                                                </div>
                                                                {/* <img src='/images/delete-icon.svg' onClick={() => removeSkill(el)} alt='' width={16} /> */}
                                                            </div>

                                                        )
                                                    })}
                                            </div>

                                        }
                                        <div className='mt-4'>
                                            <h5>Additional questions</h5>
                                            <p>{testDetails?.testDetails?.questions?.length ? `${testDetails?.testDetails?.questions?.length} Qs` : 'No questions added yet'}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='selected-question'>
                                    <h3>Additional Question</h3>
                                    <p>These questions are shown before the test</p>
                                    {testDetails?.testDetails?.questions?.length > 0 ?
                                        testDetails?.testDetails?.questions && testDetails?.testDetails?.questions?.map((el, i) => {
                                            return (
                                                <div className='question d-flex justify-content-between align-items-center' key={el?.questionID}>
                                                    <h4 className='elipsis-2' dangerouslySetInnerHTML={{ __html: el?.question }} />
                                                    <div>
                                                        {el?.questionTypeName === 'Multiple Choice' ?
                                                            <img src='/images/mcq.svg' alt='' /> :
                                                            <img src='/images/essay.svg' alt='' width={20} />
                                                        }
                                                        <span> {el?.questionTypeName}</span>
                                                    </div>
                                                    <div>
                                                        <img src='/images/info.svg' className='cursor-pointer' alt='' />&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                </div>
                                            )
                                        }) :
                                        <p>0 Qs 0 Mins</p>
                                    }
                                </div>
                            </div>
                    }
                </Modal.Body>

            </Modal>
        </div>
    )
}
